// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bbc_a","InstagramEmbed__mask":"bbc_b bhv_bi bhv_bo bhv_vt"};